declare var Glider: any;

jQuery(function ($) {
    const gliderEl = document.querySelector('.glider');

    if (gliderEl) {
        new Glider(gliderEl, {
            slidesToScroll: 1,
            slidesToShow: 'auto',
            itemWidth: 330,
            draggable: true,
            dots: '.dots',
            arrows: {
                prev: '.glider-prev',
                next: '.glider-next'
            }
        });
    }
});